import React, { useReducer, useState } from "react";
import axios from "axios";
import "./adminregistration.css";
import { useSnackbar } from "notistack";
import IsLoading from "../../../isLoading";
import { Link, redirect, useNavigate } from "react-router-dom";
let data;

const initialState = {
  live: true,
  account_status: "In-active",
  staffID: "",
  first_Name: "",
  sur_Name: "",
  other_Name: "",
  other_Name: "",
  email: "",
  phoneNumber: "",
  position: "",
  office: "",
  qualification: "",
  yearsInService: "",
  dateOfAppointment: "",
  status: "",
  profileImage: "",
  personalInfo: {
    gender: "",
    dateOfBirth: "",
    maritalStatus: "",
    nationality: "",
    stateOfOrigin: "",
    localGovtArea: "",
    address: {
      permanent: "",
      current: "",
    },
  },
  contactInfo: {
    alternativeEmail: "",
    officePhone: "",
    nextOfKin: {
      fullName: "",
      relationship: "",
      phone: "",
      address: "",
    },
  },
  employmentDetails: {
    employmentType: "",
    department: "",
    faculty: "",
    specialization: "",
    employmentHistory: [],
  },
  responsibilities: [],
  financialRecords: {
    salary: {
      monthlySalary: "",
      currency: "",
      lastPaidDate: "",
    },
    pensionScheme: {
      status: "",
      pensionProvider: "",
      contributions: "",
    },
    allowances: [],
  },
  accommodationAllocation: {
    staffQuarters: "",
    roomNumber: "",
    status: "",
  },
  libraryRecords: {
    borrowedBooks: [],
  },
  healthRecords: {
    bloodGroup: "",
    allergies: [],
    medicalHistory: [],
  },
  auth: {
    username: "",
    passwordHash: "",
    role: "",
    lastLogin: "",
  },
  emergencyContact: {
    name: "",
    relationship: "",
    phone: "",
    address: "",
  },
  termsOfService: false,
};

const reducer = (state, action) => {
  switch (action.type) {
    case "UPDATE_FIELD":
      return { ...state, [action.field]: action.value };
    case "UPDATE_NESTED_FIELD":
      return {
        ...state,
        [action.parent]: {
          ...state[action.parent],
          [action.field]: action.value,
        },
      };
    case "UPDATE_DEEP_NESTED_FIELD":
      return {
        ...state,
        [action.parent]: {
          ...state[action.parent],
          [action.child]: {
            ...state[action.parent][action.child],
            [action.field]: action.value,
          },
        },
      };
    default:
      return state;
  }
};

const AdminRegistration = () => {
  const redirect = useNavigate();
  const [loading, setLoading] = useState(false);
  const { enqueueSnackbar, closeSnackbar } = useSnackbar();
  const [state, dispatch] = useReducer(reducer, initialState);

  const handleChange = (e, field, parent, child) => {
    const value =
      e.target.type === "checkbox" ? e.target.checked : e.target.value;
    if (parent && child) {
      dispatch({
        type: "UPDATE_DEEP_NESTED_FIELD",
        parent,
        child,
        field,
        value,
      });
    } else if (parent) {
      dispatch({ type: "UPDATE_NESTED_FIELD", parent, field, value });
    } else {
      dispatch({ type: "UPDATE_FIELD", field, value });
    }
  };

  const handleSubmit = async () => {
    setLoading(true);
    try {
      const response = await axios.post(
        `${process.env.REACT_APP_SERVER_SCRIPT_HOST}/admin_registration`,
        state
      );
      data = response.data.data;
      enqueueSnackbar(`Administrative Staff Registration Success!`, {
        variant: "success",
        autoHideDuration: 3000,
        ContentProps: {
          style: { fontSize: "16px", fontWeight: "bold" },
        },
      });
      redirect("/management_login");
    } catch (error) {
      console.log("Error:", error);
      enqueueSnackbar(`Registration failed, please try again`, {
        variant: "error",
        autoHideDuration: 3000,
        ContentProps: {
          style: { fontSize: "16px", fontWeight: "bold" },
        },
      });
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="adminRegCont">
      {loading ? <IsLoading /> : null}
      <div className="fx-cl space4">
        <div className="fx-cl">
          <h2>Registration Form</h2>
          {/* <div className="fx-cl spacem ">
            <span className="passportRwdRegForm" style={{ maxWidth: "20rem" }}>
              <PassportUpload />
            </span>
          </div> */}
          <div className="rwdG3 g g3 space2">
            <label className="fx-cl spacem">
              First Name:
              <input
                type="text"
                value={state.first_Name}
                onChange={(e) => handleChange(e, "first_Name")}
              />
            </label>
            <label className="fx-cl spacem">
              Surname:
              <input
                type="text"
                value={state.sur_Name}
                onChange={(e) => handleChange(e, "sur_Name")}
              />
            </label>
            <label className="fx-cl spacem">
              Surname:
              <input
                type="text"
                value={state.other_Name}
                onChange={(e) => handleChange(e, "other_Name")}
              />
            </label>
            <label className="fx-cl spacem">
              Email:
              <input
                type="email"
                value={state.email}
                onChange={(e) => handleChange(e, "email")}
              />
            </label>
          </div>
          <div className="rwdG4 g g4 space2">
            <label className="fx-cl spacem">
              Phone Number:
              <input
                type="text"
                value={state.phoneNumber}
                onChange={(e) => handleChange(e, "phoneNumber")}
              />
            </label>
            <label className="fx-cl spacem">
              Gender:
              <select
                value={state.personalInfo.gender}
                onChange={(e) => handleChange(e, "gender", "personalInfo")}
              >
                <option value="Male">Male</option>
                <option value="Female">Female</option>
              </select>
            </label>
            <label className="fx-cl spacem">
              Nationality:
              <input
                type="text"
                value={state.personalInfo.nationality}
                onChange={(e) => handleChange(e, "nationality", "personalInfo")}
              />
            </label>
            <label className="fx-cl spacem">
              Password:
              <input
                type="password"
                value={state.auth.passwordHash}
                onChange={(e) => handleChange(e, "passwordHash", "auth")}
              />
            </label>
          </div>
        </div>
        <div className="fx-cl">
          {/* <h3>Health Records</h3>
          <div className="rwdG2 g g2 space2">
            <label className="fx-cl spacem">
              Blood Group:
              <input
                type="text"
                name="bloodGroup"
                value={state.healthRecords.bloodGroup}
                onChange={(e) => handleChange(e, "bloodGroup", "healthRecords")}
              />
            </label>

            <label className="fx-cl spacem">
              Allergies:
              <input
                type="text"
                name="allergies"
                value={state.healthRecords.allergies}
                onChange={(e) => handleChange(e, "allergies", "healthRecords")}
              />
            </label>
          </div> */}
          {/* <h4>Medical History</h4>
          <div className="rwdG4 g g4 space2">
            {state.healthRecords.medicalHistory.map((record, index) => (
              <div key={index} className="std_form-medicalHistory">
                <label className="fx-cl spacem">
                  Condition:
                  <input
                    type="text"
                    name={`medicalHistory[${index}].condition`}
                    value={record.condition}
                  />
                </label>
                <label className="fx-cl spacem">
                  Blood Group:
                  <input
                    type="text"
                    name="bloodGroup"
                    value={state.healthRecords.bloodGroup}
                    onChange={(e) =>
                      handleChange(e, "bloodGroup", "healthRecords")
                    }
                  />
                </label>

                <label className="fx-cl spacem">
                  Diagnosed Year:
                  <input
                    type="number"
                    name={`medicalHistory[${index}].diagnosedYear`}
                    value={record.diagnosedYear}
                    readOnly
                  />
                </label>
              </div>
            ))}
          </div> */}
          <h3>Emergency Contact</h3>
          <div className="rwdG3 g3 g space2">
            <label className="fx-cl spacem">
              Name:
              <input
                type="text"
                name="emergencyContact.name"
                value={state.emergencyContact.name}
                onChange={(e) => handleChange(e, "name", "emergencyContact")}
              />
            </label>

            <label className="fx-cl spacem">
              Relationship:
              <input
                type="text"
                name="emergencyContact.relationship"
                value={state.emergencyContact.relationship}
                onChange={(e) =>
                  handleChange(e, "relationship", "emergencyContact")
                }
              />
            </label>

            <label className="fx-cl spacem">
              Phone:
              <input
                type="tel"
                name="emergencyContact.phone"
                value={state.emergencyContact.phone}
                onChange={(e) => handleChange(e, "phone", "emergencyContact")}
              />
            </label>

            <label className="fx-cl spacem">
              Address:
              <input
                type="text"
                name="emergencyContact.address"
                value={state.emergencyContact.address}
                onChange={(e) => handleChange(e, "address", "emergencyContact")}
              />
            </label>
          </div>
        </div>

        {/* <div className="fx-cl">
          <h3>Employment History</h3>

          {state.employmentDetails.employmentHistory.map((job, index) => (
            <div key={index} className="std_form-job">
              <label className="fx-cl spacem">
                Institution:
                <input
                  type="text"
                  name={`employmentHistory[${index}].institution`}
                  value={job.institution}
                  readOnly
                />
              </label>

              <label className="fx-cl spacem">
                Role:
                <input
                  type="text"
                  name={`employmentHistory[${index}].role`}
                  value={job.role}
                  readOnly
                />
              </label>
              <label className="fx-cl spacem">
                Years:
                <input
                  type="text"
                  name={`employmentHistory[${index}].years`}
                  value={job.years}
                  readOnly
                />
              </label>
            </div>
          ))}
        </div> */}

        <div className="fx-cl">
          <h3>Contact Information</h3>
          <div className="rwdG2 g2 g space2">
            <label className="fx-cl spacem ">
              Alternative Email:
              <input
                type="email"
                name="contactInfo.alternativeEmail"
                value={state.contactInfo.alternativeEmail}
                onChange={(e) =>
                  handleChange(e, "alternativeEmail", "contactInfo")
                }
              />
            </label>

            <label className="fx-cl spacem">
              Office Phone:
              <input
                type="tel"
                name="contactInfo.officePhone"
                value={state.contactInfo.officePhone}
                onChange={(e) => handleChange(e, "officePhone", "contactInfo")}
              />
            </label>
          </div>
        </div>
        {/* <div className="fx-cl">
          <h4>Next of Kin</h4>
          <div className="rwdG3 g g3 space2">
            <label className="fx-cl spacem">
              Full Name:
              <input
                type="text"
                name="contactInfo.nextOfKin.fullName"
                value={state.contactInfo.nextOfKin.fullName}
                onChange={(e) =>
                  handleChange(e, "nextOfKin.fullName", "contactInfo")
                }
              />
            </label>

            <label className="fx-cl spacem">
              Relationship:
              <input
                type="text"
                name="contactInfo.nextOfKin.relationship"
                value={state.contactInfo.nextOfKin.relationship}
                onChange={(e) =>
                  handleChange(e, "nextOfKin.relationship", "contactInfo")
                }
              />
            </label>

            <label className="fx-cl spacem">
              Phone:
              <input
                type="tel"
                name="contactInfo.nextOfKin.phone"
                value={state.contactInfo.nextOfKin.phone}
                onChange={(e) =>
                  handleChange(e, "nextOfKin.phone", "contactInfo")
                }
              />
            </label>
          </div>
        </div> */}
        {/* <label className="fx-cl spacem">
          Address:
          <input
            type="text"
            name="contactInfo.nextOfKin.address"
            value={state.contactInfo.nextOfKin.address}
            onChange={(e) =>
              handleChange(e, "address", "contactInfo.nextOfKin")
            }
          />
        </label> */}

        <button type="submit" onClick={() => handleSubmit()}>
          Submit
        </button>
      </div>
    </div>
  );
};

export default AdminRegistration;
